import { render, staticRenderFns } from "./xuesheng.vue?vue&type=template&id=553f2607&"
import script from "./xuesheng.vue?vue&type=script&lang=js&"
export * from "./xuesheng.vue?vue&type=script&lang=js&"
import style0 from "./xuesheng.vue?vue&type=style&index=0&id=553f2607&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports